import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import Image from 'vibo-ui/Image';
import ContentArea from 'components/common/ContentArea';
import EventTypeIcon from 'components/events/common/EventTypeIcon';

import { useEvent } from 'components/context/EventContext';

import { EventImagesProps } from './interfaces';
import { ChangeEventImageStep } from 'types/enums';

import useStyles from './style';

const EventImages: FC<PropsWithChildren<EventImagesProps>> = ({
  onClick,
  id,
  title,
  type,
  isUpdating,
  className,
  squareUrl = '',
  children,
}) => {
  const classes = useStyles();

  const eventContext = useEvent();

  return (
    <ContentArea className={classNames(classes.eventImages, 'eventImages', className)} shadowed>
      <Image
        onClick={() => onClick?.(ChangeEventImageStep.cropSquare)}
        src={squareUrl}
        gradientId={id}
        alt={title}
        className={classNames(classes.imgSquare)}
        isUpdating={isUpdating}
        isPickable={!!onClick && !!eventContext?.canEdit}
      >
        {type ? <EventTypeIcon type={type} /> : <span />}
        {children}
      </Image>
    </ContentArea>
  );
};

export default EventImages;
